<form>
  <div class="row">
  <div class="col-md-12 col-xl-12">
    <div class="table-responsive our-table">
      <table class="table table-striped text-nowrap mb-0">
        <thead class="border-top">
          <tr>

            <th scope="col">Data</th>
            <th scope="col">Id de Transação</th>
            <th scope="col"> </th>
            <th scope="col">Tipo</th>
            <th scope="col">Status</th>
            <th scope="col">Valor Solicitado</th>
            <th scope="col">Taxas</th>
            <th scope="col"> {{ nameColumn }} </th>
            <th scope="col">Valor Movimentado</th>
            <th scope="col">Origem</th>
            <th scope="col">Descrição</th>
            <th scope="col">IdempotencyKey</th>
          </tr>
        </thead>
        <tbody>
        <tr class="border-bottom" *ngFor="let transaction of transactions">
            <td><span>{{transaction.data | date : 'dd/MM/yyyy HH:mm:ss':'GMT'}}</span></td>
            <td><span>{{transaction.codigo}}</span></td>
            <td><span *ngIf="transaction.tipo === 'Saque'
                             && (transaction.origem === 'PIX' && isValidPixDate(transaction.data) || transaction.origem === 'TEF' && isValidTefDate(transaction.data))"
                            ><i class="btn fe fe-file" (click)="downloadReceipt(transaction)"></i></span></td>
            <td><span class="font-weight-bold text-{{transaction.textColor}}">{{transaction.tipo}}</span></td>
            <td><span>{{transaction.status}}</span></td>
            <td><span>R$ {{ transaction.valorSolicitado | mask: 'separator.2': { decimalMarker: ',', thousandSeparator: '.', leadZero: true } }}</span></td>
            <td><span>R$ {{ ((!transaction.splitTaxa && !transaction.splitTaxaAdm) ? transaction.taxaAdministrativa : transaction.splitTaxaAdm) | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</span></td>
            <td><span>R$ {{transaction.splitTaxa | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</span></td>
            <td><span>R$ {{transaction.valorMovimentado | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</span></td>
            <td><span>{{transaction.origem}}</span></td>
            <td><span>{{transaction.responsavel}}</span></td>
            <td><span>{{transaction.idempotencyKey}}</span></td>
          </tr>
          <tr *ngIf="transactions.length == 0">
            <td colspan="12">Não contém dados</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-between p-2">
      <ngb-pagination
        [collectionSize]="total" [maxSize]="5" [rotate]="true" [(page)]="page" [pageSize]="pageSize" (pageChange)="pageChange()">
      </ngb-pagination>
    </div>
    </div>
  </div>
</form>
